module.exports = __webpack_public_path__ + "img/samsung-galaxy-book-s-5.679c421.jpg";